import React, { createContext, useContext, useEffect, useState } from 'react';

export const DeviceWidthContext = createContext(null);

export const useDeviceWidth = () => {
  return useContext(DeviceWidthContext);
};

export const DeviceWidthProvider: React.FC<{}> = ({ children }) => {
  const getDeviceWidth = () => {
    const width = window.innerWidth;

    let deviceType = 'D'; // Default Desktop

    if (width <= 768) {
      deviceType = 'M'; // Mobile
    }

    return { width, deviceType };
  };

  const [deviceWidth, setDevieWidth] = useState(getDeviceWidth());

  useEffect(() => {
    const handleResize = () => {
      setDevieWidth(getDeviceWidth());
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <DeviceWidthContext.Provider value={deviceWidth}>
      {children}
    </DeviceWidthContext.Provider>
  );
}
